<div [style.text-align]="field.cellOpts.linkAlign ?? 'left'">
    @if (field.btnOpts.navigates) {
        <a [routerLink]="field.getNavRoute(focusItem)">
            {{field.getFormattedValue(focusItem)}}
        </a>
    } @else if (field.btnOpts.navItem || field.btnOpts.navRouteCalculator) {
        @if (field.btnOpts.navRouteCalculator(focusItem)) {
            <a [routerLink]="['/' + field.btnOpts.navRouteCalculator(focusItem), field.btnOpts.navParmCalculator(focusItem)]">
                {{field.getFormattedValue(focusItem)}}
            </a>
        } @else {
            {{field.getFormattedValue(focusItem)}}
        }
    } @else if (field.btnOpts.tableClickMethod && !field.btnOpts.tableClickLinksTo) {
        <!-- e.g. Open Unit/Person from the requests list -->
        <button mat-button (click)="$event.stopPropagation(); field.btnOpts.tableClickMethod(focusItem);"
            [color]="field.btnOpts.color">
            {{field.getValue(focusItem)}}
        </button>
    } @else if (field.btnOpts.tableClickMethod && field.btnOpts.tableClickLinksTo) {
        <a [href]="field.btnOpts.tableClickLinksTo(focusItem)" (click)="$event.preventDefault(); $event.stopPropagation(); field.btnOpts.tableClickMethod(focusItem);">
            {{field.getValue(focusItem)}}
        </a>
    } @else {
        <span>{{field.getValue(focusItem)}}</span>
    }
</div>
